import { render, staticRenderFns } from "./searchBar.vue?vue&type=template&id=576bff7d&"
import script from "./searchBar.vue?vue&type=script&lang=js&"
export * from "./searchBar.vue?vue&type=script&lang=js&"
import style0 from "../../style/search.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/kivateknoloji/kivacloud/corona-ux/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('576bff7d')) {
      api.createRecord('576bff7d', component.options)
    } else {
      api.reload('576bff7d', component.options)
    }
    module.hot.accept("./searchBar.vue?vue&type=template&id=576bff7d&", function () {
      api.rerender('576bff7d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/TagsView/header/searchBar.vue"
export default component.exports